module.exports = __webpack_public_path__ + "img/header-diamondJewelryWhitegold.3bcebb6.webp";